"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends")),
    _react = _interopRequireDefault(require("react")),
    _reactApollo = require("react-apollo"),
    _getOrgMemberships = _interopRequireDefault(require("../api/getOrgMemberships")),
    _getOrganisationByAlias = _interopRequireDefault(require("../api/getOrganisationByAlias")),
    _AuthorisationProvider = _interopRequireDefault(require("../components/AuthorisationProvider")),
    _RequestProvider = _interopRequireDefault(require("../../RequestProvider")),
    _WithPublicLink = _interopRequireDefault(require("../../WithPublicLink"));

function AuthorisationProvider(a) {
  var b = a.children;
  return _react["default"].createElement(_RequestProvider["default"], {
    requests: {
      getOrgMemberships: (0, _getOrgMemberships["default"])(),
      getOrganisationByAlias: (0, _getOrganisationByAlias["default"])()
    }
  }, function (a) {
    return _react["default"].createElement(_reactApollo.ApolloConsumer, null, function (c) {
      return _react["default"].createElement(_AuthorisationProvider["default"], (0, _extends2["default"])({
        apiClient: c
      }, a), b);
    });
  });
}

var _default = (0, _WithPublicLink["default"])(AuthorisationProvider);

exports["default"] = _default;